import { InputMask } from '@react-input/mask';
import cx from 'classnames';
import type React from 'react';
import { useState } from 'react';
import { useController } from 'react-hook-form';
import IconButtonForPass from '@/shared/Buttons/IconButton/iconButtonForPass';
import { Icons } from '@/shared/Icons/Icons';
import styles from './input.module.css';

interface InputProps {
  label?: string;
  name: string;
  control: any;
  rules?: any;
  type?: string;
  minWidth?: number;
  placeholder?: string;
  onChangeMask?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  autocomplete?: string;
  mask?: string;
  min?: number;
  max?: number;
}

const Input: React.FC<InputProps> = ({
  label,
  name,
  control,
  rules,
  type = 'text',
  minWidth = 100,
  placeholder = '',
  onChangeMask,
  autocomplete = '',
  mask,
  min,
  max,
}) => {
  const {
    field: { value, onChange, onBlur, ref },
    fieldState: { invalid, error },
  } = useController({
    name,
    control,
    rules,
    defaultValue: '',
  });

  const [showPassword, setShowPassword] = useState(type !== 'password');

  // Определяем, является ли поле обязательным
  const isRequired = Boolean(rules?.required);

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const onMainChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChangeMask) onChangeMask(event);
    onChange(event);
  };

  // Функция для добавления звездочки к placeholder
  const getPlaceholderWithAsterisk = () => {
    return isRequired ? `${placeholder}*` : placeholder;
  };

  if (mask) {
    return (
      <div>
        {label ? (
          <label className={styles.label}>
            {label}:{isRequired && <span className={styles.required}>*</span>}
          </label>
        ) : null}
        <div className={styles.passwordContainer}>
          <InputMask
            mask={mask}
            replacement={{ _: /\d/ }}
            value={value}
            onChange={onMainChange}
            onBlur={onBlur}
            ref={ref}
            style={{ minWidth }}
            placeholder={getPlaceholderWithAsterisk()}
            className={cx(styles.mainInput, invalid ? styles.error : '')}
            autoComplete={autocomplete}
            type={type}
            {...(type === 'number' && min !== undefined ? { min } : {})}
            {...(type === 'number' && max !== undefined ? { max } : {})}
          />
        </div>
        <div className={styles.errorContainer}>
          {invalid && error && (
            <span className={styles.errorText}>{error.message}</span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div>
      {label ? (
        <label className={styles.label}>
          {label}:{isRequired && <span className={styles.required}>*</span>}
        </label>
      ) : null}
      <div className={styles.passwordContainer}>
        <input
          type={
            type === 'password' ? (showPassword ? 'text' : 'password') : type
          }
          value={value}
          onChange={onMainChange}
          onBlur={onBlur}
          ref={ref}
          style={{ minWidth }}
          placeholder={getPlaceholderWithAsterisk()}
          className={cx(styles.mainInput, invalid ? styles.error : '')}
          autoComplete={autocomplete}
          {...(type === 'number' && min !== undefined ? { min } : {})}
          {...(type === 'number' && max !== undefined ? { max } : {})}
        />
        {type === 'password' && (
          <div className={styles.passwordButton}>
            <IconButtonForPass
              icon={<Icons.NoShow />}
              ariaLabel="показать"
              onClick={toggleShowPassword}
              isActive={showPassword}
            />
          </div>
        )}
      </div>
      <div className={styles.errorContainer}>
        {invalid && error && (
          <span className={styles.errorText}>{error.message}</span>
        )}
      </div>
    </div>
  );
};

export default Input;
